var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"color":"white","opacity":"0.5","value":_vm.isPageLoading}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"96"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }